<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        class="lds-wave"
        viewBox="0 0 100 100"
        preserveAspectRatio="xMidYMid"
        :class="className"
    >
        <circle cx="11" cy="38.086" :r="radius" fill="#e15b64">
            <animate
                attributeName="cy"
                values="30;70;30"
                times="0;0.5;1"
                dur="1s"
                calcMode="spline"
                keySplines="0.5 0 0.5 1;0.5 0 0.5 1"
                begin="0s"
                repeatCount="indefinite"
            ></animate>
        </circle>
        <circle cx="22" cy="56.4712" :r="radius" fill="#f47e60">
            <animate
                attributeName="cy"
                values="30;70;30"
                times="0;0.5;1"
                dur="1s"
                calcMode="spline"
                keySplines="0.5 0 0.5 1;0.5 0 0.5 1"
                begin="-0.125s"
                repeatCount="indefinite"
            ></animate>
        </circle>
        <circle cx="33" cy="68.3092" :r="radius" fill="#f8b26a">
            <animate
                attributeName="cy"
                values="30;70;30"
                times="0;0.5;1"
                dur="1s"
                calcMode="spline"
                keySplines="0.5 0 0.5 1;0.5 0 0.5 1"
                begin="-0.25s"
                repeatCount="indefinite"
            ></animate>
        </circle>
        <circle cx="44" cy="69.6081" :r="radius" fill="#abbd81">
            <animate
                attributeName="cy"
                values="30;70;30"
                times="0;0.5;1"
                dur="1s"
                calcMode="spline"
                keySplines="0.5 0 0.5 1;0.5 0 0.5 1"
                begin="-0.375s"
                repeatCount="indefinite"
            ></animate>
        </circle>
        <circle cx="55" cy="61.914" :r="radius" fill="#e15b64">
            <animate
                attributeName="cy"
                values="30;70;30"
                times="0;0.5;1"
                dur="1s"
                calcMode="spline"
                keySplines="0.5 0 0.5 1;0.5 0 0.5 1"
                begin="-0.5s"
                repeatCount="indefinite"
            ></animate>
        </circle>
        <circle cx="66" cy="43.5288" :r="radius" fill="#f47e60">
            <animate
                attributeName="cy"
                values="30;70;30"
                times="0;0.5;1"
                dur="1s"
                calcMode="spline"
                keySplines="0.5 0 0.5 1;0.5 0 0.5 1"
                begin="-0.625s"
                repeatCount="indefinite"
            ></animate>
        </circle>
        <circle cx="77" cy="31.6908" :r="radius" fill="#f8b26a">
            <animate
                attributeName="cy"
                values="30;70;30"
                times="0;0.5;1"
                dur="1s"
                calcMode="spline"
                keySplines="0.5 0 0.5 1;0.5 0 0.5 1"
                begin="-0.75s"
                repeatCount="indefinite"
            ></animate>
        </circle>
        <circle cx="88" cy="30.3919" :r="radius" fill="#abbd81">
            <animate
                attributeName="cy"
                values="30;70;30"
                times="0;0.5;1"
                dur="1s"
                calcMode="spline"
                keySplines="0.5 0 0.5 1;0.5 0 0.5 1"
                begin="-0.875s"
                repeatCount="indefinite"
            ></animate>
        </circle>
    </svg>
</template>
<script>
import Vue from "vue";

export default Vue.extend({
    name: "SnakeSpinner",
    props: {
        radius: {
            type: Number,
            default: 5,
        },
        className: {
            type: String,
            default: "",
        },
    },
});
</script>

<style scoped lang="scss">
svg {
    width: 20px;
    height: 20px;
}
</style>
